import { render, staticRenderFns } from "./setJudgmentByVoiceSimulation.vue?vue&type=template&id=6ddf41f1&scoped=true"
import script from "./setJudgmentByVoiceSimulation.vue?vue&type=script&lang=js"
export * from "./setJudgmentByVoiceSimulation.vue?vue&type=script&lang=js"
import style0 from "./setJudgmentByVoiceSimulation.vue?vue&type=style&index=0&id=6ddf41f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddf41f1",
  null
  
)

export default component.exports